module.exports = __webpack_public_path__ + "img/ztdownloading.7e67d14c.svg";